import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NonReturnableComponent } from './non-returnable.component';

@NgModule({
  imports: [CommonModule],
  declarations: [NonReturnableComponent],
  exports: [NonReturnableComponent],
})
export class NonReturnableModule {}
